import { FidoUserRequestObj, StudentPagination, StudentPaginationParameters } from "@carnegie-learning/data-access-angular-passport";
import { createAction, props } from "@ngrx/store";
import { CourseMetrics, Student, User } from "cli-types";

// ------ Load students ------
export const loadStudents = createAction(
    "[Students] Load Students",
    props<{
        payload: StudentPaginationParameters;
        courseID: number;
    }>()
);
export const loadStudentsFail = createAction(
    "[Students] Load Students Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadStudentsSuccess = createAction(
    "[Students] Load Students Success",
    props<{
        payload: StudentPagination;
    }>()
);
export const removeStudents = createAction(
    "[Students] Remove Students Success"
);
// ------ Set Pagination Params -------
export const setStudentPaginationParams = createAction(
    "[Students] Set Pagination Params",
    props<{
        payload: any;
    }>()
);

// ------ Set Filter Box State -------
export const setStudentFilterBoxOpened = createAction(
    "[Students] Filter Box Opened",
    props<{
        payload: any;
    }>()
);

// ------ Load student ------
export const loadStudent = createAction(
    "[Students] Load Student",
    props<{
        studentID: number;
    }>()
);
export const loadStudentFail = createAction(
    "[Students] Load Student Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadStudentSuccess = createAction(
    "[Students] Load Student Success",
    props<{
        payload: Student;
    }>()
);

// ------ Load studentMetrics ------
export const loadStudentMetrics = createAction(
    "[Students] Load Student Metrics"
);
export const loadStudentMetricsFail = createAction(
    "[Students] Load Student Metrics Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadStudentMetricsSuccess = createAction(
    "[Students] Load Student Metrics Success",
    props<{
        payload: CourseMetrics;
    }>()
);
// ------ Create FIDO Student ------
export const createFidoStudent = createAction(
    "[Student] Create Fido Student",
    props<{
        payload: Student;
        schoolID: string;
        courseID: number;
    }>()
);
export const createFidoStudentFail = createAction(
    "[Student] Create Fido Student Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const createFidoStudentSuccess = createAction(
    "[Student] Create Fido Student Success",
    props<{
        fidoData: User;
    }>()
);

// ------ Add FIDO Student to Passport ------
export const addStudent = createAction(
    "[Student] Add Fido Student",
    props<{
        payload: User;
        password: string | null;
    }>()
);
export const addStudentFail = createAction(
    "[Student] Add Fido Student Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const addStudentSuccess = createAction(
    "[Student] Add Fido Student Success",
    props<{
        fidoData: User;
        payload: Student;
    }>()
);

// ------ Add FIDO Student to Passport via Array ------
export const addStudents = createAction(
    "[Students] Added Fido Students",
    props<{
        studentIDList: string[];
        courseID: number;
        syncAssignments: boolean;
        school?: string;
    }>()
);
export const addStudentsSuccess = createAction(
    "[Students] Added Fido Students Success",
    props<{
        payload: Student[];
        school?: string;
    }>()
);
export const addStudentsFail = createAction(
    "[Students] Added Fido Students Fail",
    props<{
        payload: any;
    }>()
);

// ------ Update Passport student profile ------
export const updateStudent = createAction(
    "[Students] Update Passport student profile",
    props<{
        payload: Student;
    }>()
);
export const updateStudentFail = createAction(
    "[Students] Update Passport student profile Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const updateStudentSuccess = createAction(
    "[Students] Update Passport student profile Success",
    props<{
        payload: Student;
    }>()
);

// ------ Update Passport student profile ------
export const updateFidoStudent = createAction(
    "[Students] Update Fido student profile",
    props<{
        user: FidoUserRequestObj;
        fidoUserID: string;
    }>()
);
export const updateFidoStudentFail = createAction(
    "[Students] Update Fido student profile Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const updateFidoStudentSuccess = createAction(
    "[Students] Update Fido student profile Success",
    props<{
        payload: any;
    }>()
);

// ------ Update Student's School Permission ----//
export const updateSchoolPermissionSuccess = createAction(
    "[Students] Update Student's School permission Success"
);

export const updateSchoolPermissionFail = createAction(
    "[Students] Update Student's School permission fail",
    props<{
        payload: string;
    }>()
);

// ------ Archive student ------
export const archiveStudent = createAction(
    "[Students] Archive Student",
    props<{
        payload: Student;
    }>()
);
export const archiveStudentFail = createAction(
    "[Students] Archive Student Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const archiveStudentSuccess = createAction(
    "[Students] Archive Student Success",
    props<{
        payload: Student;
    }>()
);

// ------ Reactivate student ------
export const reactivateStudent = createAction(
    "[Students] Reactivate Student",
    props<{
        payload: Student;
    }>()
);
export const reactivateStudentFail = createAction(
    "[Students] Reactivate Student Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const reactivateStudentSuccess = createAction(
    "[Students] Reactivate Student Success",
    props<{
        payload: Student;
    }>()
);

// ------ Remove student ------
export const removeStudent = createAction(
    "[Students] Remove Student",
    props<{
        payload: Student;
    }>()
);
export const removeStudentFail = createAction(
    "[Students] Remove Student Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const removeStudentSuccess = createAction(
    "[Students] Remove Student Success",
    props<{
        payload: Student;
    }>()
);

export const resetStudentsStore = createAction(
    "[Students] Reset Student Store"
);

// ------ Load Students Fido Data ------
export const loadStudentsFidoData = createAction(
    "[Students] Load Students Fido Data",
    props<{
        studentUUIDs: string[];
    }>()
);
export const loadStudentsFidoDataSuccess = createAction(
    "[Students] Load Students Fido Data Success",
    props<{
        fidoData: User[];
    }>()
);
export const loadStudentsFidoDataFail = createAction(
    "[Students] Load Students Fido Data Fail",
    props<{
        payload: any;
    }>()
);

// ------ Set Student Fido Password ------
export const setStudentFidoPassword = createAction(
    "[Students] Set Student Fido Password",
    props<{
        studentUUIDs: string[];
        password: string | null;
        courseID: number;
        syncAssignments: boolean;
    }>()
);
export const setStudentFidoPasswordFail = createAction(
    "[Students] Set Student Fido Password Fail",
    props<{
        payload: any;
    }>()
);

// ------ Update Student Fido Password ------
export const updateStudentFidoPassword = createAction(
    "[Students] Update Student Fido Password",
    props<{
        fidoUserID: string;
        password: string;
    }>()
);
export const updateStudentFidoPasswordSuccess = createAction(
    "[Students] Update Student Fido Password Success",
    props<{
        payload: any;
    }>()
);
export const updateStudentFidoPasswordFail = createAction(
    "[Students] Update Student Fido Password Fail",
    props<{
        payload: any;
    }>()
);
// ------ Set Student Name ------
export const setStudentName = createAction(
    "[Students] Set Student Name",
    props<{
        payload: User;
    }>()
);
